module.exports = __webpack_public_path__ + "img/icon-laba.c54f8a02.png";